
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';

interface Funnel {
  id: string | number;
  name: string;
  type: string;
}

export default defineComponent({
  name: 'FunnelsList',

  components: {
    DataTable,
    Column,
    Button,
  },

  props: {
    templateConfig: {
      type: String,
      required: true,
    },
  },

  emits: ['edit-funnel'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const parsedFunnels = computed<Funnel[]>(() => {
      try {
        const config = JSON.parse(props.templateConfig);
        if (config && config.funnels && Array.isArray(config.funnels)) {
          return config.funnels.map((funnel: Funnel) => ({
            id: funnel.id,
            name: funnel.name,
            type: funnel.type,
            labelType: t(`templates.channels.${funnel.type}`),
          }));
        }
      } catch (e) {
        console.error('Error parsing template_config JSON:', e);
      }
      return [];
    });

    const editFunnel = (templateId: number, name: string, type: string) => {
      emit('edit-funnel', templateId, name, type);
    };

    return {
      parsedFunnels,
      t,
      editFunnel,
    };
  },
});
